import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CorrespondenceFunctionActions from './function.actions';
import { CorrespondenceFunctionService } from '../../services/function.service';

@Injectable()
export class CorrespondenceFunctionEffects {
  loadCorrespondenceFunction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceFunctionActions.loadCorrespondenceFunction),
      exhaustMap((_) =>
        this.correspondenceFunctionService.getCorrespondenceFunction().pipe(
          map((data) =>
            CorrespondenceFunctionActions.loadCorrespondenceFunctionSuccess({
              correspondenceFunction: data,
            })
          ),
          catchError((error) =>
            of(
              CorrespondenceFunctionActions.loadCorrespondenceFunctionFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  addCorrespondenceFunction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceFunctionActions.addCorrespondenceFunction),
      concatMap(({ newCorrespondenceFunction }) =>
        this.correspondenceFunctionService
          .createCorrespondenceFunction(newCorrespondenceFunction)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return CorrespondenceFunctionActions.addCorrespondenceFunctionSuccess(
                {
                  newCorrespondenceFunction: data,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceFunctionActions.addCorrespondenceFunctionFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateCorrespondenceFunction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceFunctionActions.updateCorrespondenceFunction),
      map((action) => action.updateCorrespondenceFunction),
      concatMap((updateCorrespondenceFunction) =>
        this.correspondenceFunctionService
          .updateCorrespondenceFunction(updateCorrespondenceFunction)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return CorrespondenceFunctionActions.updateCorrespondenceFunctionSuccess(
                {
                  updateCorrespondenceFunction: updateCorrespondenceFunction,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceFunctionActions.updateCorrespondenceFunctionFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  removeCorrespondenceFunction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceFunctionActions.removeCorrespondenceFunction),
      map((action) => action.ids),
      concatMap((ids) =>
        this.correspondenceFunctionService
          .deleteCorrespondenceFunction(ids)
          .pipe(
            map(() => {
              this.notification.success('Deleted Successfully');
              return CorrespondenceFunctionActions.removeCorrespondenceFunctionSuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceFunctionActions.updateCorrespondenceFunctionFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private correspondenceFunctionService: CorrespondenceFunctionService,
    private notification: NotificationService
  ) {}
}
